import { defineMessages } from 'react-intl';

export default defineMessages({
  lastName: {
    id: 'authenticator.onboarding.form.lastNameLabel',
    defaultMessage: 'Last name',
  },
  firstName: {
    id: 'authenticator.onboarding.form.firstNameLabel',
    defaultMessage: 'First name',
  },
  email: {
    id: 'authenticator.onboarding.form.emailLabel',
    defaultMessage: 'Email',
  },
  phone: {
    id: 'authenticator.onboarding.form.phoneLabel',
    defaultMessage: 'Phone',
  },
  country: {
    id: 'authenticator.onboarding.form.country',
    defaultMessage: 'Country',
  },
  trialStart: {
    id: 'authenticator.onboarding.form.trialStart',
    defaultMessage: 'I start my trial',
  },
  accoundCreationSuccess: {
    id: 'authenticator.onboarding.form.accoundCreationSuccess',
    defaultMessage: 'Account created successfully',
  },
  cgvRequired: {
    id: 'authenticator.onboarding.form.cgvRequired',
    defaultMessage: 'You must accept the general conditions of use',
  },
  customerSpacePreview: {
    id: 'authenticator.onboarding.form.customerSpacePreview',
    defaultMessage: 'Your customer space: {domainName}',
  },
  customerSpaceLabel: {
    id: 'authenticator.onboarding.form.customerSpaceLabel',
    defaultMessage: 'Customer space address',
  },
  customerSpaceEdit: {
    id: 'authenticator.onboarding.form.customerSpaceEdit',
    defaultMessage: 'Modify',
  },
  customerSpaceUseSuggested: {
    id: 'authenticator.onboarding.form.customerSpaceUseSuggested',
    defaultMessage: 'Use the suggested address',
  },
  invalidCName: {
    id: 'authenticator.onboarding.form.invalidCName',
    defaultMessage:
      'Use 3 to 40 lowercase letters, digits or dashes, without a dash at the ends',
  },
  address: {
    id: 'authenticator.onboarding.form.address',
    defaultMessage: 'Address',
  },
  postalCode: {
    id: 'authenticator.onboarding.form.postalCode',
    defaultMessage: 'Postal code',
  },
  city: {
    id: 'authenticator.onboarding.form.city',
    defaultMessage: 'City',
  },
  companySection: {
    id: 'authenticator.onboarding.form.companySection',
    defaultMessage: 'Your company',
  },
  youSection: {
    id: 'authenticator.onboarding.form.youSection',
    defaultMessage: 'You',
  },
  addressSection: {
    id: 'authenticator.onboarding.form.addressSection',
    defaultMessage: 'Address',
  },
  addressFromRegister: {
    id: 'authenticator.onboarding.form.addressFromRegister',
    defaultMessage: 'Filled from the register, editable',
  },
  companyFromRegister: {
    id: 'authenticator.onboarding.form.companyFromRegister',
    defaultMessage:
      '{company} · {details}. The headquarters address is filled below: correct it if your after-sales service is elsewhere. {nextStepPrefilled}',
  },
  nextStepPrefilled: {
    id: 'authenticator.onboarding.form.nextStepPrefilled',
    defaultMessage: 'The next step is pre-filled from your activity.',
  },
  manualCompany: {
    id: 'authenticator.onboarding.form.manualCompany',
    defaultMessage:
      '{company} is not in the register: fill in the address below, and your activity at the next step.',
  },
  yourCompany: {
    id: 'authenticator.onboarding.form.yourCompany',
    defaultMessage: 'Your company',
  },
  analysingCompany: {
    id: 'authenticator.onboarding.form.analysingCompany',
    defaultMessage: 'Analysing {company}…',
  },
  sourceFrenchCompanyRegistry: {
    id: 'authenticator.onboarding.form.sourceFrenchCompanyRegistry',
    defaultMessage: 'French register',
  },
  sourceCompaniesHouse: {
    id: 'authenticator.onboarding.form.sourceCompaniesHouse',
    defaultMessage: 'Companies House',
  },
  sourceBelgianCrossroadsBank: {
    id: 'authenticator.onboarding.form.sourceBelgianCrossroadsBank',
    defaultMessage: 'BCE-KBO',
  },
  sourceGleif: {
    id: 'authenticator.onboarding.form.sourceGleif',
    defaultMessage: 'GLEIF',
  },
});
